import Vue from 'vue';
import ElementUI from 'element-ui';
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.use(BaiduMap, {
  ak: 'ycNgeGCc2kAcbGXRf9U6YnPzSpdY3Xo7'
})

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js